import { render, staticRenderFns } from "./CorrespondenceLanguageSelect.vue?vue&type=template&id=79e9d4d2"
import script from "./CorrespondenceLanguageSelect.vue?vue&type=script&lang=js"
export * from "./CorrespondenceLanguageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports